module.exports = __webpack_public_path__ + "static/media/133.294081d9.png";